

export function keyboard_special_up( code, key, shift, ctrl, alt)
{
  
  if ((code === "Alt") || (code === "AltLeft" ) || (code === "AltRight"))
  {
    if (key.length == 1) return key;
  }
  return "";

}


// à supprimer si inutile....

//var numpadSequence = "";
export function keyboard_special_down( code, key, shift, ctrl, alt)
{
  if (ctrl || shift) return false;
  if (!alt) return false;
  if (code.startsWith("Numpad")) 
  {
    if (key >="0" && key <="9")
    {
      //numpadSequence = numpadSequence + key;
      return true;
    }
  }
  return false;
}



        

    